(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define([
            'jquery',
            'bam-wiretap/Wiretap',
            'bam-wiretap/plugins/bam/MediaTimer'
        ], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS-like
        module.exports = factory(
            require('jquery'),
            require('bam-wiretap/Wiretap'),
            require('bam-wiretap/plugins/bam/MediaTimer')
        );
    } else {
        // Browser globals (root is window)
        root.WiretapVideo = factory(root.jQuery, root.Wiretap, root.MediaTimer);
    }
})(this, function($, Wiretap, MediaTimer, TokenHelpers) {
    'use strict';

    /**
     * WiretapVideo - Analytics tracking for video player events.
     * @param {object}   trackingConfig A JSON object of events to track.
     * @param {function} tokenHelpers   (optional) Function helpers to replace tracking event tokens.
     * @param {object}   pageConfig     (optional) Additional static page data.
     * @constructor
     */
    function WiretapVideo(trackingConfig, tokenHelpers, pageConfig) {
        WiretapVideo.prototype.super.constructor.call(
            this,
            trackingConfig,
            tokenHelpers,
            pageConfig
        );

        this.bandwagon = this.pageConfig.bandwagon;

        if (!this.bandwagon) {
            return;
        }

        this.screens = {};
        this.PlayerEvents = this.bandwagon.getRegisteredEventsByKey(
            'PLAYER_EVENTS'
        );
        this.AdEvents = this.bandwagon.getRegisteredEventsByKey('AD_EVENTS');
        this.ApplicationEvents = this.bandwagon.getRegisteredEventsByKey(
            'APPLICATION_EVENTS'
        );

        _initListeners.call(this);

        // Remove duration tracking temporarily.
        if (this.trackingConfig.intervals) {
            this.mediaTimer = new MediaTimer(this);
        }
    }

    // Inherit from Wiretap
    WiretapVideo.prototype = Object.create(Wiretap);
    WiretapVideo.prototype.constructor = WiretapVideo;
    WiretapVideo.prototype.super = Wiretap.prototype;

    /**
     * Track an event from the player's dispatcher.
     * @param  {object} proxyData Tracking config properties, namely: trackObj.
     * @param  {object} eventData Data passed from the dispatchd event.
     * @param  {object} e         The player event.
     */
    WiretapVideo.prototype.trackEventHandler = function(
        proxyData,
        eventData,
        e
    ) {
        var trackObj;

        if (!proxyData.trackObj) {
            return false;
        }

        // Get the right props from the single tracking_event call, based on impression key.
        if (
            e.type === 'trackingEvent' &&
            eventData.data &&
            eventData.data.impressionKey
        ) {
            var subEvents = proxyData.trackObj.wire.events;

            // Find the event w/ the fired impressionKey.
            for (var s in subEvents) {
                if (!subEvents.hasOwnProperty(s) || !subEvents[s].wire) {
                    continue;
                }
                if (
                    subEvents[s].wire.impressionKey ===
                    eventData.data.impressionKey
                ) {
                    trackObj = subEvents[s];
                    break;
                } else {
                    s++;
                }
            }

            if (!trackObj) {
                return false;
            }
        } else {
            trackObj = proxyData.trackObj;
        }

        var adobeObj = this.setTrackingProps(
            $.extend(true, {}, trackObj),
            eventData
        );

        if (adobeObj) {
            this.prototype.track(adobeObj);
        }
    };

    /**
     * Set the variables inside the tracking event object.
     * Should be overridden by the custom section implementations.
     * @param  {object} trackObj  Config properties.
     * @param  {object} eventData The player event data.
     */
    WiretapVideo.prototype.setTrackingProps = function(trackObj, eventData) {
        var _this = this;
        var screenData = {};

        screenData.player = eventData ? eventData.player : {};
        screenData.config = screenData.player.config || {};
        screenData.clip = screenData.player.clip || {};
        screenData.meta = screenData.clip.metaData || {};
        screenData.dynamicVars = {};

        if (screenData.meta.game_pk) {
            screenData.dynamicVars = this.getScreenDataForContentId(
                String(screenData.meta.game_pk)
            );
        } else if (screenData.clip.content_id) {
            screenData.dynamicVars = this.getScreenDataForContentId(
                String(screenData.clip.content_id)
            );
        }

        // Loop each property in the tracking object.
        $.each(trackObj, function(prop, value) {
            value = value.toString();

            // Parse @KEY@
            if (value.indexOf('@') !== -1) {
                trackObj[prop] = replaceTokens.call(_this, value, screenData);
            }

            // Remove any bad props.
            if (trackObj[prop] == 'undefined' || trackObj[prop] == null) {
                delete trackObj[prop];
            }
        });

        return trackObj;
    };

    /**
     * Set data for a screen.
     * @param data The screen's data, including the contentId.
     */
    WiretapVideo.prototype.setScreenDataForContentId = function(data) {
        if (data && data.contentId) {
            var id = String(data.contentId);

            this.screens[id] = data;
        }
    };

    /**
     * Look up the screen data in a local cache based on contentId.
     * @param   contentId {string} The current contentId
     * @returns           {{}}
     */
    WiretapVideo.prototype.getScreenDataForContentId = function(contentId) {
        var screenData = {};

        if (contentId) {
            var id = String(contentId);

            if (this.screens[id]) {
                screenData = this.screens[id];
            }
        }

        return screenData;
    };

    // ==================
    // Private Functions
    // ==================

    /**
     * Replace each token variable within a prop value.
     * @param str
     * @param screenData
     */
    function replaceTokens(str, screenData) {
        var matches = str.match(/@\w+@/g);
        var fnKey;

        // Call util function with the key.
        // Lookup the function to use from tokenHelpers.
        matches.forEach(
            function(match) {
                fnKey = match.substr(1, match.length - 2);
                str = str.replace(
                    match,
                    $.proxy(this.tokenHelpers[fnKey], this, screenData)
                );
            }.bind(this)
        );

        return str;
    }

    /**
     * Initialize player event listeners for automated tracking.
     */
    function _initListeners() {
        var _this = this;
        var dispatcher;
        var eventHandler;

        $.each(_this.trackingConfig.containers, function(bandwagonKey, events) {
            dispatcher = _this.bandwagon.getInstanceByKey(bandwagonKey);

            if (!dispatcher) {
                return true;
            }

            for (var e in events) {
                var trackObj = events[e];
                if (
                    !trackObj.wire ||
                    !(
                        _this.PlayerEvents[trackObj.wire.pEventKey] ||
                        _this.AdEvents[trackObj.wire.pEventKey] ||
                        _this.ApplicationEvents[trackObj.wire.pEventKey]
                    )
                ) {
                    continue;
                }

                // TRACKING_EVENT subEvents
                if (trackObj.wire.events) {
                    // Add defaults to all event sub-tracking objects.
                    var subEvents = trackObj.wire.events;

                    // Extend the Tracking_Event controls
                    for (var s in subEvents) {
                        if (
                            !subEvents.hasOwnProperty(s) ||
                            !subEvents[s].wire
                        ) {
                            continue;
                        }
                        if (subEvents[s].wire.defaults) {
                            $.extend(
                                subEvents[s],
                                _this.trackingConfig.defaults[
                                    subEvents[s].wire.defaults
                                ]
                            );
                        }
                    }

                    trackObj.wire.events = subEvents;
                } else {
                    if (trackObj.wire.defaults) {
                        $.extend(
                            trackObj,
                            _this.trackingConfig.defaults[
                                trackObj.wire.defaults
                            ]
                        );
                    }
                }

                eventHandler = $.proxy(_this.trackEventHandler, _this, {
                    trackObj: trackObj
                });

                if (trackObj.wire.eventsModel === 'AdEvents') {
                    dispatcher.on(
                        _this.AdEvents[trackObj.wire.pEventKey],
                        eventHandler
                    );
                } else if (trackObj.wire.eventsModel === 'ApplicationEvents') {
                    dispatcher.on(
                        _this.ApplicationEvents[trackObj.wire.pEventKey],
                        eventHandler
                    );
                } else {
                    // Default is PlayerEvents
                    dispatcher.on(
                        _this.PlayerEvents[trackObj.wire.pEventKey],
                        eventHandler
                    );
                }
            } // End forEvents.
        });
    }

    //return instance || new WiretapVideo;
    return WiretapVideo;
});
